// Import model
import { UpdateBomKitItemRequest } from '../models/UpdateBomKitItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateBomKitItemRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateBomKitItemRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateBomKitItemRequest instance
   */
  static deserialize(json: string): UpdateBomKitItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateBomKitItemRequest instance
   */
  static fromObject(obj: any): UpdateBomKitItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateBomKitItemRequest');
    }


    const instance: UpdateBomKitItemRequest = {
      createdBy: obj['createdBy'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      bomKitId: obj['bomKitId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateBomKitItemRequest instances
   */
  static deserializeArray(json: string): UpdateBomKitItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateBomKitItemRequest instance to a JSON string
   */
  static serialize(instance: UpdateBomKitItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateBomKitItemRequest instance to a plain object
   */
  static toObject(instance: UpdateBomKitItemRequest): any {
    return {
      'createdBy': instance.createdBy,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'bomKitId': instance.bomKitId,
    };
  }

  /**
   * Serializes an array of UpdateBomKitItemRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateBomKitItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
